import { CallingStatusValues } from '@/constants/callingStatus';
import { AutocompleteResultWithTooltip, CatCampaignRecord } from '@/types';

export const CALLING_STATUS_OPTIONS_IDS = CallingStatusValues.filter(
  (x: string) => x !== 'Uncalled'
).map((x: string) => {
  return { id: x.charCodeAt(0), label: x };
});

export const mapCampaignsToTooltips = (
  campaign: CatCampaignRecord
): AutocompleteResultWithTooltip => {
  return {
    id: campaign.id,
    chipLabel: campaign.name,
    label: campaign.label,
    tooltipContent: campaign.label,
  };
};
